import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IBudgetItem } from '../../blueprint';
import TableHeadings from './table-headings';
import TableRow from './table-row';
import { useFormContext, useWatch } from 'react-hook-form';
import textCss from '../../../../../components/form/elements/text.module.css';

interface CostsTableProps {
  costs: IBudgetItem;
}

export default function CostsTable({ costs }: CostsTableProps) {
  const { t } = useTranslation();
  const formMethods = useFormContext();
  const { register, getValues, setValue } = formMethods;

  const watchValues = useWatch({
    name: costs.calculable,
    disabled: !costs.calculable,
  });

  useEffect(() => {
    function setSum(sum: number) {
      sum = parseFloat(sum.toFixed(2));
      if (getValues(costs.name) !== sum) {
        if (sum !== 0) {
          setValue(costs.name, sum);
          costs.value = sum;
        } else {
          setValue(costs.name, 0);
          costs.value = 0;
        }
      }
    }

    if (watchValues && watchValues.length) {
      const sum = watchValues.reduce((accumulator, currentValue) => {
        if (
          (typeof currentValue === 'number' && !isNaN(currentValue)) ||
          typeof currentValue === 'string'
        ) {
          return parseFloat((accumulator + Number(currentValue)).toFixed(2));
        }
        return accumulator;
      }, 0);
      setSum(sum);
    }
  }, [setValue, getValues, watchValues, costs]);

  return (
    <>
      {costs && Object.keys(costs.children) ? (
        <input
          type="hidden"
          name={costs.name}
          data-name={costs.name + '_input'}
          className={textCss['input']}
          {...register(costs.name)}
          defaultValue={costs.value}
          disabled={true}
        />
      ) : null}
      {costs &&
        Object.keys(costs.children) &&
        Object.keys(costs.children).map((costName: any) => {
          const cost: any = costs.children[costName];

          return (
            <div key={`row-container-${cost.name}`}>
              <TableHeadings
                item={cost}
                title={t(cost.title)}
                summ={cost.value}
                key={`row-head-${cost.name}-${+new Date()}`}
              />

              {cost.children &&
                cost.children.map((child: any) => {
                  return <TableRow key={`row-${child.name}`} item={child} />;
                })}
            </div>
          );
        })}
    </>
  );
}
